module.exports = __webpack_public_path__ + "img/三相混合式逆变器.e7da5316.png";